import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableHost,
  TableRow,
} from '@/components/Table'
import styles from './BulkActionJobErrorDialog.module.css'
import { byDesign } from '@/infra/design'
import imgArchiveItemUrl from '@/assets/misc/img_archive-item.svg'
import DocumentsDisabledIllustration from '@/components/SpotIllustration/DocumentsDisabledIllustration'
import { type BulkActionJobError } from '@/features/jobs/list/components/BulkActionJobErrorDialog/BulkActionJobErrorDialogViewModel'

export interface BulkActionJobErrorDialogProps {
  showing: boolean
  errors: readonly BulkActionJobError[]
  onClose: () => unknown
}

export function BulkActionJobErrorDialog({
  showing,
  errors,
  onClose,
}: BulkActionJobErrorDialogProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose} large>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgArchiveItemUrl}
            illustration={byDesign(undefined, DocumentsDisabledIllustration)}
            alt="Jobs can't be cloned"
          />
          <ModalSheetContentTitle>
            These jobs can't be processed
          </ModalSheetContentTitle>
        </ModalSheetContentBlock>
        <ModalSheetContentBlock>
          <TableHost>
            <Table striped>
              <TableHead>
                <TableHeader align="left">Job title</TableHeader>
                <TableHeader align="left">Job ID</TableHeader>
                <TableHeader align="left">Error</TableHeader>
              </TableHead>
              <TableBody>
                {errors.map((error) => (
                  <TableRow key={error.jobId}>
                    <TableCell
                      align="left"
                      className={styles.copyJobErrorJobId}
                    >
                      {error.jobTitle}
                    </TableCell>
                    <TableCell align="left">{error.jobId}</TableCell>
                    <TableCell
                      align="left"
                      className={styles.copyJobErrorMessage}
                    >
                      {error.error}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableHost>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" onPress={onClose} />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
